<ion-menu contentId="main-content" style="--width: 280px">
	<app-drawer />
</ion-menu>

<ion-tabs id="main-content">
	<ion-tab-bar slot="bottom" class="h-15 pb-[env(safe-area-inset-bottom)] bg-(--ion-color-dark)">
		<ion-tab-button tab="home" href="/home">
			<ion-icon name="home-outline"></ion-icon>
			<ion-label>{{ 'Home' | translate }}</ion-label>
		</ion-tab-button>

		<ion-tab-button tab="my-markets" href="/my-markets">
			<ion-icon name="star"></ion-icon>
			<ion-label>{{ 'My Markets' | translate }}</ion-label>
		</ion-tab-button>

		<ion-tab-button (click)="openCasino()">
			<ion-icon name="diamond-outline"></ion-icon>
			<ion-label>{{ 'Casino' | translate }}</ion-label>
		</ion-tab-button>

		<ion-tab-button tab="my-bets" href="/my-bets">
			<ion-icon name="document-text-outline"></ion-icon>
			<ion-label>{{ 'My Bets' | translate }}</ion-label>
		</ion-tab-button>
	</ion-tab-bar>
</ion-tabs>
